export const scrollToSection = () => {
    const tabLinks = document.querySelectorAll(".tab-block a");
    const contentItems = document.querySelectorAll(".content-item");

    if (!tabLinks.length || !contentItems.length) return;

    tabLinks.forEach((link, index) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();

            // Active tab
            tabLinks.forEach((item) => item.classList.remove("active"));
            link.classList.add("active");

            // Scroll to section
            const targetSection = contentItems[index];

            if (targetSection) {
                const headerHeight = document.querySelector("header")?.offsetHeight || 0;

                const offsetTop =
                    targetSection.getBoundingClientRect().top +
                    window.pageYOffset -
                    headerHeight -
                    40;

                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                });
            }
        });
    });
};